import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { PhilosophySection } from "@/components/PhilosophySection";
import { VerticalsSection } from "@/components/VerticalsSection";
import { WhyOjasSection } from "@/components/WhyOjasSection";
import { CaseStudySection } from "@/components/CaseStudySection";
import { ArchitectureSection } from "@/components/ArchitectureSection";
import { ComplianceSection } from "@/components/ComplianceSection";
import { PartnersSection } from "@/components/PartnersSection";
import { CareersSection } from "@/components/CareersSection";
import { ContactSection } from "@/components/ContactSection";
import { FooterSection } from "@/components/FooterSection";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background font-body">
      <Navbar />
      <HeroSection />
      <PhilosophySection />
      <VerticalsSection />
      <WhyOjasSection />
      <CaseStudySection />
      <ArchitectureSection />
      <ComplianceSection />
      <PartnersSection />
      <CareersSection />
      <ContactSection />
      <FooterSection />
    </div>
  );
}
